export enum Locale {
    EN = 'en',
    DE = 'de',
    ES = 'es',
  }
  
  export default Locale